import { render, staticRenderFns } from "./activeData.vue?vue&type=template&id=602f2234"
import script from "./activeData.vue?vue&type=script&lang=js"
export * from "./activeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports